import React from "react";
import styled from "styled-components";
import { Select, ConfigProvider } from "antd";

const theme = {
  token: {
    
  },
};

const FormSelect = ({ ...props }) => {
  return (
    <ConfigProvider theme={theme}>
      <_Select {...props} />
    </ConfigProvider>
  );
};

const _Select = styled(Select)`
  border-radius: 50px;

  ::placeholder {
    color: var(--aia-bx-gray-2);
  }

  :-webkit-autofill,
  :-webkit-autofill:hover, 
  :-webkit-autofill:focus, 
  :-webkit-autofill:active  {
    transition: background-color 5000s;
  }

  &:hover, &:focus {
    box-shadow: 0px 0px 0.5rem 0px rgba(2, 114, 174, 0.2);
  }
`;

export default FormSelect;